import React, { useEffect } from "react";
import { Field, FieldInputProps, useFormikContext } from "formik";
import { Checkbox, Column, Columns, Stack } from "@origin-digital/ods-core";
import GeneralTextField from "./GeneralTextField";
import HelperText from "./HelperText";
import FormikSelectField from "./FormikSelectField";
import { ElectricityBlockValues } from "../types";

const MaxLoad: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<ElectricityBlockValues>();
  const showTransformer = ["2", "3"].includes(values.phases);

  useEffect(() => {
    setFieldValue("transformer", false);
  }, [values.phases]);

  return (
    <Columns
      collapseBelow="md"
      space={{ xs: "none", md: "xlarge" }}
      alignY="stretch"
    >
      <Column width="2/3">
        <Stack space={{ xs: "small", md: "medium" }}>
          <Columns
            collapseBelow="sm"
            space={{
              xs: "xlarge",
              md: "medium",
            }}
          >
            <Column>
              <Field
                component={GeneralTextField}
                name="maxLoad"
                label="Max load, Amps"
                type="number"
              />
            </Column>
            <Column>
              <Field
                name="phases"
                label="Phases"
                component={FormikSelectField}
                options={[
                  {
                    label: "1",
                    value: "1",
                  },
                  {
                    label: "2",
                    value: "2",
                  },
                  {
                    label: "3",
                    value: "3",
                  },
                ]}
              />
            </Column>
          </Columns>
          {showTransformer && (
            <Field type="checkbox" name="transformer">
              {/* eslint-disable-next-line react/no-unused-prop-types */}
              {({ field }: { field: FieldInputProps<boolean> }) => (
                <Checkbox
                  label="Current transformer (CT metering) required"
                  id="transformer"
                  checked={field.value}
                  onChange={(e) => field.onChange(e)}
                />
              )}
            </Field>
          )}
        </Stack>
      </Column>
      <Column>
        <HelperText text="If the load is greater than 80 Amps, CT metering is usually required. Check with your electrician if you're not sure." />
      </Column>
    </Columns>
  );
};

export default MaxLoad;
